// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// Crop
export const formatCropName = (name: string) => `${name}`;

// Order
export const formatOrderName = (id: string, short = false) => (short ? `${id}` : `Order ${id}`);

// Recurring Order
export const formatRecurringOrderName = (id: string, short = false) => (short ? `${id}` : `Recurring Order ${id}`);

// Recurring Task
export const formatRecurringTaskName = (id: string, short = false) => (short ? `${id}` : `Recurring Task ${id}`);

// Recurring Planting
export const formatRecurringPlantingName = (id: string, short = false) =>
  short ? `${id}` : `Recurring Planting ${id}`;

// Harvest
export const formatHarvestName = (id: string, short = false) => (short ? `${id}` : `Harvest ${id}`);

// Planting
export const formatPlantingName = (id: string, short = false) => (short ? `${id}` : `Planting ${id}`);

// Task
export const formatTaskName = (id: string, short = false) => (short ? `${id}` : `Task ${id}`);

// Blend
export const formatBlendName = (id: string, short = false) => (short ? `${id}` : `Blend ${id}`);

// Lost Trays
export const formatLostTraysName = (id: string, short = false) => (short ? `${id}` : `Incident ${id}`);
